export default __webpack_public_path__ + "static/media/VE.3d0b1d24.svg";